import { MenuOption } from "@lexical/react/LexicalTypeaheadMenuPlugin";

export class ChannelTypeaheadOption extends MenuOption {
  channel_id: string;
  display: string;
  constructor(channel_id: string, display: string) {
    super(channel_id);
    this.channel_id = channel_id;
    this.display = display;
  }
}
